<template>
    <table class="table-detail bg-hard-white">
        <thead>
            <tr>
                <th v-for="column in columns">{{ column }}</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td v-for="(data, index) in data" :key="index">
                    {{ data }}
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>

export default {
    name: 'TableDetail',
    props: {
        data:{
            type: Array
        },
        columns: {
            type: Array
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/TableDetail.vue